import { Star } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ILinkedSkill, IOtherEmployerDetails, IPrivateProjectFormPackage } from '../../../interfaces/projects/IProjects'
import { useStore } from '../../../Provider'
import { Data, OPNewTable } from '../../OPcomponents/OPNewTable'
import AddNewPrivateProject from './newprivproject/AddNewPrivateProject'
import { formatDateFi } from './workHistoryHelpers'

const PrivateWorkHistoryTable = (props: { rowId: number | undefined }): JSX.Element => {
  const rootStore = useStore()
  const { rowId } = props
  const { t } = useTranslation()
  const { validatedUser } = rootStore.loginStore
  const { projects, getDetailedUserProjects, allOtherEmployerDetails } = rootStore.projectStore

  const { filteredPrivateWorkHistories } = rootStore.personStore

  const tableRows: Data[] = []

  const onRowClickHandler = async (id: number | string) => {
    const clickedProject = projects.find((proj) => proj.project.projectId === id)?.project
    if (clickedProject) {
      const userDetails = await getDetailedUserProjects(validatedUser, clickedProject?.projectId)
      const employerDetails =
        allOtherEmployerDetails.find((emp) => emp.employerId === clickedProject?.employerId) ?? ({} as IOtherEmployerDetails)

      const projectInfo: IPrivateProjectFormPackage = {
        project: clickedProject,
        userDetails,
        employerDetails,
      }
      return projectInfo
    }
  }

  filteredPrivateWorkHistories.forEach((work) => {
    tableRows.push({
      ['key']: work.projectId,
      ['id']: work.projectId,
      rows: {
        [t('Skills.EmployerJob')]: { text: work.empDetails[0]?.name + ' - ' + work.empDetails[0]?.jobTitle, width: '32%' },
        [t('Projects.ProjectName')]: { text: work.projectName, width: '22%' },
        [t('Projects.ProjectStartDate')]: { text: formatDateFi(work.startDate), width: '10%' },
        [t('Projects.ProjectEndDate')]: { text: formatDateFi(work.endDate), width: '10%' },
        [t('WorkHistory.Expirience')]: {
          text: `${work.daysWorked || 0} ${t('Date.ExperienceDays')}`,
          width: '8%',
          align: 'right' as const,
        },
        [t('Projects.KeyProject')]: {
          text: work.isKeyProject ? <Star color='primary' /> : '',
          width: '9%',
          align: 'center' as const,
        },
        [t('WorkHistory.Skills')]: {
          text: (
            <Tooltip
              title={work.linkedSkills
                .map((s: ILinkedSkill) => (getI18n().language === 'en' && s.skillNameEng?.length ? s.skillNameEng : s.skillNameFi))
                .join(', ')}
              placement='bottom'
              arrow
            >
              <span>{work.linkedSkills.length}</span>
            </Tooltip>
          ),
          width: '5%',
          align: 'right' as const,
        },
        [t('WorkHistory.Roles')]: {
          text: (
            <Tooltip
              title={
                work.roles?.map((r) => (getI18n().language === 'en' && r.roleNameEng?.length ? r.roleNameEng : r.roleNameFi)).join(', ') ||
                ''
              }
              placement='bottom'
              arrow
            >
              <span>{work.roles?.length || 0}</span>
            </Tooltip>
          ),
          width: '5%',
          align: 'right' as const,
        },
      },
    })
  })

  return tableRows.length ? (
    <OPNewTable
      rows={tableRows}
      curLength={tableRows.length}
      profileclickedId={rowId}
      onRowClick={onRowClickHandler}
      FormBase={AddNewPrivateProject}
    />
  ) : (
    <span>{t('WorkHistory.NoPrivateWorkHistory')}</span>
  )
}

export default observer(PrivateWorkHistoryTable)
